import { render, staticRenderFns } from "./time-range.vue?vue&type=template&id=01235ab2&"
import script from "./time-range.vue?vue&type=script&lang=js&"
export * from "./time-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01235ab2')) {
      api.createRecord('01235ab2', component.options)
    } else {
      api.reload('01235ab2', component.options)
    }
    module.hot.accept("./time-range.vue?vue&type=template&id=01235ab2&", function () {
      api.rerender('01235ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/date-picker/panel/Time/time-range.vue"
export default component.exports